import React, { Component } from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
// Import common components
import { Input, Autocomplete } from "arv-reactcomponents";

@inject("StoreLocatorStore")
@observer
class StoreBrandAutocomplete extends Component {
  static getList(item) {
    return (
      <li className="nw-storelocatorform-autocompletelist" key={item}>
        {item}
      </li>
    );
  }
  constructor(props) {
    super(props);
    this.onInpValChange = this.onInpValChange.bind(this);
    this.getInput = this.getInput.bind(this);
    this.getAutocompleteSelection = this.getAutocompleteSelection.bind(this);
  }

  onInpValChange(e) {
    this.props.onBrandSelection(e.target.value);
  }

  getAutocompleteSelection(selectedValue) {
    this.props.onBrandSelection(selectedValue);
  }

  getInput() {
    const { brand } = this.props;
    return (
      <Input
        id="nw-sl-brnadinputbox"
        className="nw-storelocatorform-input"
        placeholder="Enter Brand Name"
        value={brand}
        onChange={this.onInpValChange}
        onBlur={this.props.onBlur}
        autocomplete="off"
      />
    );
  }

  render() {
    return (
      <Autocomplete
        className="nw-storelocatorform-autocomplete"
        inpList={toJS(this.props.StoreLocatorStore.brandsList)}
        getSelection={this.getAutocompleteSelection}
        renderInput={this.getInput}
        renderList={StoreBrandAutocomplete.getList}
      />
    );
  }
}

StoreBrandAutocomplete.defaultProps = {
  brand: "",
};

StoreBrandAutocomplete.propTypes = {
  brand: PropTypes.string,
  onBrandSelection: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

StoreBrandAutocomplete.wrappedComponent.propTypes = {
  StoreLocatorStore: PropTypes.shape({
    brandsList: PropTypes.object,
  }).isRequired,
};

export default StoreBrandAutocomplete;



// WEBPACK FOOTER //
// ./src/component/StoreLocatorForm/StoreBrandAutocomplete/index.js